import styled from "styled-components";
import React from "react";

const FieldDiv = styled.div`
    margin-top: 1rem;
`;

let ErrorDiv = styled.div`
    border: solid red 1px;
    border-radius: 0.5em;
    box-sizing: border-box;
    display: inline-block;
    margin-top: 1em;
    padding: 1em;
    width: 20em;
`;

const Error = ({ children }) => (
    <ErrorDiv className="error">{children}</ErrorDiv>
);

export { Error, FieldDiv };



// WEBPACK FOOTER //
// ./src/components/FieldDiv.js